import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';
import _cloneDeep from 'lodash/cloneDeep';

export function createInitialCheckedProductsMap(products = []) {
  return products.reduce((acc, product) => {
    const productVariants = _get(product, 'productVariants', []);
    return updateCheckedProducts(acc, product, productVariants);
  }, {});
}

export function updateCheckedProducts(
  currentChecked = {},
  product = {},
  productVariants = []
) {
  const checked = _cloneDeep(currentChecked);
  const productId = _get(product, 'ObjectId', '');
  const totalVariants = _size(productVariants);
  const variantsKey = `${productId}.variants`;
  const checkedVariantsCount = _size(_get(checked, variantsKey, {}));
  const areAllVariantsChecked = checkedVariantsCount === totalVariants;

  if (areAllVariantsChecked) {
    delete checked[productId];
  } else {
    checked[productId] = { data: product };
    checked[productId].variants = productVariants.reduce(
      (acc, productVariant) => {
        const productVariantId = _get(productVariant, 'objectID');
        acc[productVariantId] = productVariant;
        return acc;
      },
      {}
    );
  }

  return checked;
}

export function updateCheckedProductVariants(
  currentChecked = {},
  product = {},
  productVariant = {}
) {
  const checked = _cloneDeep(currentChecked);
  const productId = _get(product, 'ObjectId', '');
  const productVariantId = _get(productVariant, 'objectID');
  const key = `${productId}.variants.${productVariantId}`;
  const isChecked = _get(checked, key, false);

  if (isChecked) {
    delete checked[productId].variants[productVariantId];
    if (_isEmpty(checked[productId].variants)) {
      delete checked[productId];
    }
  } else {
    if (!(productId in checked)) {
      checked[productId] = { data: product };
      checked[productId].variants = {};
    }
    checked[productId].variants[productVariantId] = productVariant;
  }

  return checked;
}
